import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import Card from '../../components/Card/Card';
import DataTable from '../../components/DataTable/DataTable';
import { IColInfo } from '../../components/DataTable/Interfaces';
import { ApplicationFunctions, useAuth } from '../../contexts/authContext';
import { useNotifications } from '../../contexts/notificationContext';
import DataService from "../../services/data.service";
import Divisions_popup_AddDivision from './Popups/Divisions_popup_AddDivision';

const Divisions: React.FC = () => {
    const [data, setData] = useState<any[]>();
    const [showPopup, setShowPopup] = useState<boolean>(false);
    const { handleResult, handleException } = useNotifications();
    const { isAuthorizedFor } = useAuth();

    useEffect(() => {
        getTableData();
    }, []);

    function getTableData() {
        DataService.get<any[]>('api/v1/divisions')
            .then(response => {
                setData(response);
            })
            .catch(e => { handleException(e); });
    }

    function deleteRow(rowData) {
        DataService.delete('api/v1/divisions/', rowData.id)
            .then(response => {
                handleResult(response);
                getTableData();
            })
            .catch(e => { handleException(e); });
    }

    const colInfos: IColInfo[] = [
        { title: 'ID', key: true, dataProp: 'id', dataType: 'number' },
        { title: 'Name', dataProp: 'name', sort: 'asc', filterInfo: { filterType: 'Textbox' } },
        { title: 'Begin date', dataProp: 'beginDate', dataType: 'date', width: 120, align: 'right' },
        { title: 'End date', dataProp: 'endDate', dataType: 'date', width: 120, align: 'right' },

    ];
    if (isAuthorizedFor(ApplicationFunctions.EditDesignPhase)) {
        colInfos.push(
            {
                headerButtons: [{ text: "Add", icon: 'fa-plus-square', color: '#26A69A', onClick: () => setShowPopup(true) }],
                rowButtons: [{ text: "Delete", icon: 'fa-trash', color: '#F3565D', onClick: deleteRow }],
            });
    }

    return (
        <>
            <div className='main-content'>
                <Container fluid>
                    <Row>
                        <Col md={12}>
                            <Card title='Divisions'
                                content={
                                    <DataTable
                                        name='dtDivisions'
                                        tableData={data}
                                        colInfos={colInfos}
                                        navigateTitle='Division'
                                        navigateUrl='/plm/itemsetup/division/'
                                    />
                                }
                            />
                        </Col>
                    </Row>
                </Container>
            </div>
            {showPopup && (<Divisions_popup_AddDivision show={showPopup} onHide={() => { setShowPopup(false); getTableData(); }} />)}
        </>
    );
}
export default Divisions;